import React from 'react'

const useAudio = () => {
  
  const play = (resource) => {
    const audio = document.querySelector('.audio-'+resource);
    audio.play();
  }

  const stop = (resource) => {
    const audio = document.querySelector('.audio-'+resource);
    audio.pause();
    audio.currentTime = 0;
  }

  const pause = (resource) => {
    const audio = document.querySelector('.audio-'+resource);
    audio.pause();
  }

  const fadeOut = (resource) => {
    const audio = document.querySelector('.audio-'+resource);

    const fader = setInterval(() => {      
      if (audio.volume.toFixed(1) > 0.1) {
        audio.volume -= 0.1;
      } else {
        audio.volume = 0
        audio.pause();
        clearInterval(fader);
      }
    }, 100);
  }

  const fadeIn = (resource) => {
    const audio = document.querySelector('.audio-'+resource);

    const fader = setInterval(() => {      
      audio.volume = 0;
      audio.play();

      if (audio.volume.toFixed(1) < 0.9) {
        audio.volume += 0.1;
      } else {
        audio.volume = 1
        clearInterval(fader);
      }
    }, 100);
  }

  const restart = (resource) => {
    const audio = document.querySelector('.audio-'+resource);
    console.log(audio.volume.toFixed(1));

    audio.currentTime = 0;
    audio.volume = 1;
    audio.play();
  }

  return {
    play,
    stop,
    pause,
    fadeOut,
    fadeIn,
    restart,
  };
  
}

export default useAudio;